import type { CareProfileAnswer } from '@karehero/models';

import type { BenefitsCalculatorAnswers } from 'config/benefitsCalculatorV2Steps';

/** The options a care profile answer picks: a JSON list for a multi-select, else the one. */
export const parseAnswerValue = (value?: string | null): string[] => {
  if (!value) return [];
  if (!value.startsWith('[')) return [value];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    // Not a list after all; an answer we can't read is shown as not known.
    return [];
  }
};

/** The care profile's answers as option ids, by question; one with nothing to read is left out. */
export const answersByQuestion = (
  answers: readonly CareProfileAnswer[],
): BenefitsCalculatorAnswers => {
  const byQuestion: BenefitsCalculatorAnswers = {};
  for (const answer of answers) {
    const optionIDs = parseAnswerValue(answer.value);
    if (optionIDs.length) byQuestion[answer.careProfileQuestionId] = optionIDs;
  }
  return byQuestion;
};
